import React from "react";
import { MdClose } from "react-icons/md";
import ContainedButton from "components/layout/form/containedButton";
import { ReactComponent as Success } from "assets/icons/icon-success.svg";

import {
  Container,
  ContainerButtons,
  ModalHeader,
  ModalStyle,
  Alert,
} from "./styles";

function PasswordSuccessModal({ openModal, modalFunction, text }) {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
          <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Success />
        <Alert>
          {text}
        </Alert>
        <ContainerButtons>
          <ContainedButton onClick={() => modalFunction(false)}>
            OK
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default PasswordSuccessModal;
